import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import { requestSearchUsers } from 'redux/modules/users';
import { accountLoginFail } from 'redux/modules/account';

const ProductClaimViewItemDriver = ({
  ID,
  disabled,
  change,
  className,
  actions,
}) => (
  <Field
    className={className}
    id={`${ID}-orderLine.Driver Name`}
    name={`${ID}-orderLine.Driver Name`}
    component={AutosuggestField}
    placeholder="-Select Driver-"
    fullWidth
    listWidth="auto"
    disabled={disabled}
    renderSuggestionContent={suggestion => (
      `${suggestion['First Name']} ${suggestion['Last Name']}`
    )}
    renderInputContent={suggestion => (
      `${suggestion['First Name']} ${suggestion['Last Name']}`
    )}
    onSuggestionSelected={(suggestion) => {
      change(`${ID}-orderLine.Selected Driver Name`, `${suggestion['First Name']} ${suggestion['Last Name']}`);
      change(`${ID}-orderLine.Driver ID`, suggestion.ID);
      return `${suggestion['First Name']} ${suggestion['Last Name']}`;
    }}
    fetchSuggestions={({ value, limit, offset }) => (
      value.length > 0
        ? requestSearchUsers({
          filters: [
            {
              name: 'Role',
              operation: 'eq',
              val: 'Driver',
            },
            {
              name: 'Active',
              operation: 'eq',
              val: 'true',
            },
            {
              name: 'Full Name',
              operation: 'startswith',
              val: value,
              case_sensitivity: false,
            },
          ],
          limit,
          offset,
        }).then(res => res.data,
          (error) => {
            if (error.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return error;
          })
        : requestSearchUsers({
          filters: [
            {
              name: 'Role',
              operation: 'eq',
              val: 'Driver',
            },
            {
              name: 'Active',
              operation: 'eq',
              val: 'true',
            },
          ],
          limit,
          offset,
        }).then(res => res.data,
          (error) => {
            if (error.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return error;
          })
    )}
    onlyConfirmedSelection
  />
);

ProductClaimViewItemDriver.propTypes = {
  ID: PropTypes.number.isRequired,
  change: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

ProductClaimViewItemDriver.defaultProps = {
  className: '',
  options: null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  ProductClaimViewItemDriver,
);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaimView/ProductClaimViewItemDriver.js